import Collapsible from 'react-collapsible';
import React from 'react';

import './style.sass';

const CommonCollapseItem = ({
    big = true,
    white = null,
    gray = false,
    isNumber = true,
    content,
    index,
    numberColor = 'red',
    triggerText,
    classParent = '',
}) => {
    const Trigger = ({ index, triggerText }) => (
        <div className="common-collapse-item__title">
            <div className="common-collapse-item__info">
                <div
                    className={`common-collapse-item__number 
                 ${!isNumber ? 'common-collapse-item__number--not-number' : ''}
                 `}
                    style={{ color: numberColor }}
                >
                    {index}.
                </div>
                <div dangerouslySetInnerHTML={{ __html: triggerText }} />
            </div>
            {content.length > 0 && (
                <div className="common-collapse-item__img">
                    <img src="/images/svg/common-item__arrow.svg" alt="" loading="lazy" />
                </div>
            )}
        </div>
    );
    return (
        <div
            className={`common-collapse-item ${classParent} ${
                gray ? 'common-collapse-item--gray' : ''
            } ${white ? 'common-collapse-item--white' : ''} ${
                big ? 'common-collapse-item--big' : ''
            }`}
            key={index}
        >
            <Collapsible
                openedClassName={'active'}
                triggerTagName={'div'}
                trigger={<Trigger index={index} triggerText={triggerText} />}
                contentInnerClassName={`common-collapse-item__content 
                     ${!isNumber ? 'common-collapse-item__content--not-number' : ''}
                     `}
            >
                {content}
            </Collapsible>
        </div>
    );
};

export default CommonCollapseItem;
